import { render } from "./LorenzAttractor.vue?vue&type=template&id=62489e1e&scoped=true"
import script from "./LorenzAttractor.vue?vue&type=script&lang=js"
export * from "./LorenzAttractor.vue?vue&type=script&lang=js"

import "./LorenzAttractor.vue?vue&type=style&index=0&id=62489e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62489e1e"]])

export default __exports__